/** Item do inbox do colaborador (`GET /v1/notificacoes`). */
export type Notificacao = {
  id: number;
  idPublicacao?: number | null;
  idEvento?: number | null;
  dataEvento?: string | null;
  idComentario?: number | null;
  idAluno?: number | null;
  /** tipo_notificacao (1–9) de contracts/enums.yaml. */
  tipo?: number | null;
  titulo?: string | null;
  mensagem?: string | null;
  status: number;
  lida: boolean;
  criadoEm?: string | null;
  visualizadoEm?: string | null;
  /** Dia da atividade (`yyyy-mm-dd`). O link usa este dia, nao `criadoEm`. */
  dataPublicacao?: string | null;
};

export type NotificacoesPagina = {
  itens: Notificacao[];
  proximoCursor?: string | null;
};

export type NotificacoesResumo = {
  naoLidas: number;
};

/** Payload do evento STOMP `NOTIFICACAO_NOVA`. */
export type NotificacaoRealtime = {
  idPublicacao?: number;
  idEvento?: number;
  dataEvento?: string;
  idComentario?: number;
  idNotificacao?: number;
  idAluno?: number;
  tipo?: number;
  titulo?: string;
  mensagem?: string;
  dataPublicacao?: string;
};

export function lerNotificacaoRealtime(
  payload: Record<string, unknown>,
): NotificacaoRealtime | null {
  const idPublicacao = payload.idPublicacao;
  const idEvento = payload.idEvento;
  const temPublicacao = typeof idPublicacao === 'number' && idPublicacao > 0;
  const temEvento = typeof idEvento === 'number' && idEvento > 0;
  if (!temPublicacao && !temEvento) return null;
  const numero = (valor: unknown): number | undefined =>
    typeof valor === 'number' ? valor : undefined;
  const texto = (valor: unknown): string | undefined =>
    typeof valor === 'string' && valor.length > 0 ? valor : undefined;
  return {
    idPublicacao: temPublicacao ? idPublicacao : undefined,
    idEvento: temEvento ? idEvento : undefined,
    dataEvento: texto(payload.dataEvento),
    idComentario: numero(payload.idComentario),
    idNotificacao: numero(payload.idNotificacao),
    idAluno: numero(payload.idAluno),
    tipo: numero(payload.tipoNotificacao),
    titulo: texto(payload.titulo),
    mensagem: texto(payload.mensagem),
    dataPublicacao: texto(payload.dataPublicacao),
  };
}
